import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import useContacts from '../../hooks/useContacts'
import { useStyles } from './style'
import SelectInput from '../SelectInput'
import { ButtonPrimary } from '../ButtonPrimary'
import QuickTable from '../QuickTable'
import { ButtonSecondary } from '../ButtonSecondary'

const actionLabel = {
  insert: 'Inserção',
  update: 'Alteração',
  delete: 'Exclusão'
}

const fieldLabel = {
  name: 'Nome',
  number: 'Número',
  email: 'E-mail',
  site: 'Site',
  pessoa: 'Pessoa',
  apelido: 'Apelido',
  disableBot: 'Bot desativado',
  blacklist: 'Bloqueado',
  silencioso: 'Finalização silenciosa',
  defaultQueueId: 'Departamento padrão',
  profilePicUrl: 'Foto de perfil',
  silencedFor: 'Silenciado para',
  tags: 'Tags'
}
const ContactAuditLogsModal = ({ open, onClose, contactId }) => {
  const classes = useStyles()
  const { getContactAuditLogs } = useContacts()

  const [records, setRecords] = useState([])
  const [pageNumber, setPageNumber] = useState(1)
  const [hasMore, setHasMore] = useState(false)
  const [loading, setLoading] = useState(false)
  const [action, setAction] = useState('')

  const loadLogs = useCallback(
    async (page = 1, reset = false) => {
      if (!contactId || !open) {
        return
      }

      try {
        setLoading(true)
        const response = await getContactAuditLogs(contactId, {
          pageNumber: String(page),
          action
        })

        const loadedRecords = response?.records || []
        setRecords(prev =>
          reset ? loadedRecords : [...prev, ...loadedRecords]
        )
        setHasMore(Boolean(response?.hasMore))
        setPageNumber(page)
      } catch (error) {
        toast.error(
          'Não foi possível carregar o histórico de auditoria do contato.'
        )
      } finally {
        setLoading(false)
      }
    },
    [action, contactId, getContactAuditLogs, open]
  )

  useEffect(() => {
    if (open) {
      loadLogs(1, true)
    }
  }, [loadLogs, open])

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      loadLogs(pageNumber + 1)
    }
  }

  const columns = [
    { field: 'createdAt', headerName: 'Data/Hora' },
    { field: 'username', headerName: 'Usuário' },
    { field: 'action', headerName: 'Ação' },
    { field: 'fieldName', headerName: 'Campo' },
    { field: 'oldValue', headerName: 'Valor Anterior' },
    { field: 'newValue', headerName: 'Valor Novo' }
  ]

  const customCellRenderer = {
    createdAt: item =>
      item.createdAt ? new Date(item.createdAt).toLocaleString('pt-BR') : '-',
    action: item => actionLabel[item.action] || item.action || '-',
    fieldName: item => fieldLabel[item.fieldName] || item.fieldName || '-',
    username: item => item.username || '-',
    oldValue: item => item.oldValue || '-',
    newValue: item => item.newValue || '-'
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="contact-audit-logs-title"
    >
      <DialogTitle
        id="contact-audit-logs-title"
        className={classes.dialogTitle}
      >
        Histórico de alterações realizadas neste contato.
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={4} className={classes.inputWrapper}>
            <SelectInput
              labelId="action-select-label"
              value={action}
              onChange={event => setAction(event.target.value)}
              label="Escolha uma Ação"
            >
              <MenuItem value="">Todas</MenuItem>
              <MenuItem value="insert">Inserção</MenuItem>
              <MenuItem value="update">Alteração</MenuItem>
              <MenuItem value="delete">Exclusão</MenuItem>
            </SelectInput>
            <ButtonPrimary
              onClick={() => loadLogs(1, true)}
              disabled={loading}
              label="Filtrar"
              style={{ marginBottom: '2px' }}
            />
          </Grid>
        </Grid>

        <QuickTable
          data={records}
          columns={columns}
          loading={loading}
          customCellRenderer={customCellRenderer}
          emptyMessage="Nenhum log encontrado."
          tableProps={{
            'aria-label': 'Tabela de histórico de alterações do contato'
          }}
        />

        {hasMore && (
          <Box display="flex" justifyContent="center" marginTop={2}>
            <Button
              variant="outlined"
              onClick={handleLoadMore}
              disabled={loading}
            >
              {loading ? 'Carregando...' : 'Carregar mais'}
            </Button>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <ButtonSecondary onClick={onClose} label="Fechar" />
      </DialogActions>
    </Dialog>
  )
}

export default ContactAuditLogsModal
